const PriceCard = ({items}) => {
  if (!Array.isArray(items)) {
    return null;
  }
  return (
    <div className="flex flex-col flex-1 gap-3 max-sm:px-0 max-lg:px-20 px-12">
      <div style={{width: "100%"}}>
        {items?.map((pris, index) => (
          <div className="flex flex-col items-center w-full" key={index}>
            <div
              className="flex w-full justify-center shadow-white p-5 rounded-lg h-full overflow-hidden hover:overflow-auto mb-20">
              <div
                className="body-jost text-gray prose max-w-none prose-base leading-relaxed font-sans"
                dangerouslySetInnerHTML={{__html: pris.item}}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PriceCard;
